import React from 'react'
import './Wwo.css'
import CountUpOnScroll from '../../Home/About/ScrollCounter'
import cs from '../../../../assets/img/globe.svg'
import pd from '../../../../assets/img/project_delivered.svg'
import te from '../../../../assets/img/te.svg'
import yoe from '../../../../assets/img/yoe.svg'
import cwad from '../../../../assets/img/cwad.svg'
import ecde from '../../../../assets/img/ecde.svg'
import swad from '../../../../assets/img/swad.svg'
import pwa from '../../../../assets/img/pwa.svg'
import wasm from '../../../../assets/img/wasm.svg'

function Wwo() {

  const wwolist = [
    {
      icon:cwad,
      title: "Step 1: Idea Validation",
      desc: "Share your project scope, goals, and technical requirements. We validate your app idea through market research, target audience analysis, and demand assessment. We then create a development schedule, budget, and project plan."
    },
    {
      icon:ecde,
      title: "Step 2: Strategy Development",
      desc: "We develop a detailed app strategy that aligns with your business objectives and budget. This includes defining app features, user personas, and UX design. We also select the platforms and technology stack for development."
    },
    {
      icon:swad,
      title: "Step 3: App Deployment",
      desc: "Our cross-platform development services ensure the app infrastructure is built as planned. We create the UI, integrate features, and set up necessary infrastructure like databases and servers."
    },
    {
      icon:pwa,
      title: "Step 4: Launch & Marketing",
      desc: "Once the app is ready, we assist with its launch and marketing. This includes creating marketing materials, generating awareness, and preparing for app store submissions to maximize downloads and visibility."
    },
    {
      icon:wasm,
      title: "Step 5: Final Testing",
      desc: "Thorough testing ensures the app is error-free and functions as intended. We test for functionality, usability, and compatibility across devices and operating systems, using beta testing to gather feedback."
    },
    {
      icon:cwad,
      title: "Step 6: Funding",
      desc: "We guide you in preparing your investor pitch and exploring funding options like personal savings, loans, investors, crowdsourcing, or grants. Continuous updates and upgrades are crucial for app success."
    },
  ]

  return (
    <section className='wwo-sec'>
        <div className='container'>
            <div className='pht-sec'>
                <ul>
                    <li><img src={cs} alt='Countries Served' width={64} height={64} loading="lazy"/><h4> <CountUpOnScroll end={25} />+</h4><p>Countries Served</p></li>
                    <li><img src={pd} alt='Projects Delivered' width={64} height={64} loading="lazy"/><h4> <CountUpOnScroll end={200} />+</h4><p>Projects Delivered</p></li>
                    <li><img src={te} alt='Tech Enthusiast' width={64} height={64} loading="lazy"/><h4> <CountUpOnScroll end={120} />+</h4><p>Tech Enthusiast</p></li>
                    <li><img src={yoe} alt='Years of Experience' width={64} height={64} loading="lazy"/><h4> <CountUpOnScroll end={10} />+</h4><p>Years of Experience</p></li>
                </ul>
            </div>
            <div className='wwo-sec1'>
            <h3>What We OfferWhat Is Our Development Process?</h3>
              <ul>
                {
                  wwolist.map((Wwo, index)=>(
                    <li key={index}>
                      <div className='wwo-icon'><img src={Wwo.icon} alt={Wwo.title} width={64} height={64}/></div>
                      <h4>{Wwo.title}</h4> 
                      <p>{Wwo.desc}</p>  
                    </li>
                  ))
                }
                   
              </ul>    
            </div> 
        </div>
    </section>
  )
}

export default Wwo
